import Skeleton from '@mui/material/Skeleton'

import { TableCell, TableRow } from './Table.styles'

export function TableLoading() {
  return (
    <>
      <TableRow>
        <TableCell>
          <Skeleton variant="text" />
        </TableCell>
        <TableCell width={'150px'}>
          <Skeleton variant="text" />
        </TableCell>
        <TableCell width={'150px'}>
          <Skeleton variant="text" />
        </TableCell>
        <TableCell width={'200px'}>
          <Skeleton variant="text" />
        </TableCell>
        <TableCell width={'100px'}>
          <Skeleton variant="text" />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <Skeleton animation="wave" variant="text" />
        </TableCell>
        <TableCell width={'150px'}>
          <Skeleton animation="wave" variant="text" />
        </TableCell>
        <TableCell width={'150px'}>
          <Skeleton animation="wave" variant="text" />
        </TableCell>
        <TableCell width={'200px'}>
          <Skeleton animation="wave" variant="text" />
        </TableCell>
        <TableCell width={'100px'}>
          <Skeleton animation="wave" variant="text" />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <Skeleton animation={false} variant="text" />
        </TableCell>
        <TableCell width={'150px'}>
          <Skeleton animation={false} variant="text" />
        </TableCell>
        <TableCell width={'150px'}>
          <Skeleton animation={false} variant="text" />
        </TableCell>
        <TableCell width={'200px'}>
          <Skeleton animation={false} variant="text" />
        </TableCell>
        <TableCell width={'100px'}>
          <Skeleton animation={false} variant="text" />
        </TableCell>
      </TableRow>
    </>
  )
}
